import type {
  FixedDepositStage,
  StoredPaymentScheduleStage,
} from '@payaca/types/payment-schedule';

export const isFixedDepositStage = (
  stage: StoredPaymentScheduleStage
): stage is FixedDepositStage =>
  stage.type === 'deposit' && stage.basis.type === 'fixed';

/**
 * The parts of a stage that hold its percentage, so stored and editable stages
 * both fit.
 */
type PercentageStage =
  | {
      type: 'deposit';
      basis:
        | { type: 'percentage'; percentageDue: number | null }
        | { type: 'fixed' };
    }
  | { type: 'instalment'; percentageDue: number | null };

/** The stage's share of the gross total. A fixed deposit has none. */
export const getStoredPercentageDue = (
  stage: PercentageStage
): number | null => {
  if (stage.type === 'instalment') return stage.percentageDue;
  return stage.basis.type === 'percentage' ? stage.basis.percentageDue : null;
};
